// extracted by mini-css-extract-plugin
export default {"container":"HeadingAndIcon_container__IYcCC","iconCircle":"HeadingAndIcon_iconCircle__zKg7K","label":"HeadingAndIcon_label__AdjAE"};